<div role="search" aria-describedby="search">
  <!-- <input type="text"
  (keyup)="searchTerm$.next($event.target.value)"> -->
  <!--  [ngClass]="accrdionList && accrdionList.length > 0 ? 'col-md-12 clear-all '
               : 'col-md-12 clear-all margin-top-5' "> class="form-label"-->
  <label for="addressSearch" id="search"   [ngClass]="pageName === 'yourPensionSavings' ? 'form-label margin-top-15' : 'form-label' ">
     {{(pageName === 'yourPensionSavings'? 'Pension provider address': 'Address search')}} 
  </label>
      <input class="form-control" style="margin-bottom: 10px;"
      id="addressSearch" name="addressSearch" [placeholder]="contentData['addressSearchplaceholder']"
      type="text" 
      (keyup)="searchTerm$.next($event.target.value)" autocomplete="off"
      >
  
<ul class="autofill" *ngIf="suggestiontext" [ngClass]="{hideList:!isListAddressEnabled}">


  <li [(value)]="suggestiontext[i]" *ngFor="let txt of suggestiontext; let i = index" (click)="onSelectAddress(txt)">
    {{txt}}
  </li>

</ul>
<div class="form-validation-error clear-both" *ngIf=" parent && parent.get('addressline1') && parent.get('addressline1').touched && parent.get('addressline1').errors">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p [id]="'address-error'">
        Please enter an address
    </p>
  </div>

</div>
